<template>
  <div>
    <Conditions />
    <Gdpr />
    <Cookies />

    <footer class="footer py-4" style="margin: auto; font-size: 0.7rem; ">
      <a
        class="btn btn-dark btn-social mx-2"
        href="https://www.facebook.com/hoppyhedgehogbrewery/"
        target="_blank"
      >
        <i class="fab fa-facebook-f"></i>
      </a>
      <a
        class="btn btn-dark btn-social mx-2"
        href="https://www.instagram.com/hoppyhedgehogbrewery/"
        target="_blank"
      >
        <i class="fab fa-instagram"></i>
      </a>
      
      <div class style="font-size: 0.7rem; margin-top: 1rem">
        <a href="/">
        <img
          src="assets/img/logo.svg"
          alt
          style="width: 50%; max-height;max-width: 6rem; margin-top: 1rem;margin-bottom: 1rem;"
        />
        </a>
        <div style="font-style: normal">Copyright © Pivo&Co s.r.o 2020</div>
      </div>
      <div
        class="row justify-content-center"
        style="padding: 0 20%; margin-top: 2rem"
      >
        <div class="col-sm-3">
          <a
            class="modalLink"
            data-toggle="modal"
            data-target="#conditionsDialog"
            >Obchodní podmínky</a
          >
        </div>
        <div class="col-sm-3">
          <a class="modalLink" data-toggle="modal" data-target="#cookiesDialog"
            >Cookies</a
          >
        </div>
        <div class="col-sm-3">
          <a class="modalLink" data-toggle="modal" data-target="#gdprDialog"
            >Podmínky zpracování osobních údajů</a
          >
        </div>
      </div>
      <div style="color: #888;margin-top:0.5rem">
          Obchodní společnost Pivo&amp;Co s.r.o. zapsaná u Městského soudu v
          Praze, pod sp. zn. C 333217
        </div>
      
    </footer>
  </div>
</template>

<script>
import Conditions from "../components/Conditions";
import Gdpr from "../components/Gdpr";
import Cookies from "../components/Cookies";
export default {
  name: "Footer",
  components: { Conditions, Gdpr, Cookies },
  methods: {},
};
</script>
